import CancelButton from "components/CancelButton";
import ConfirmBoxModal from "components/ConfirmBoxModal";
import SubmitHookForm from "components/SubmitHookForm";
import Timer from "components/Timer";
import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateBusLicensePermitType,
  busLicensePermitTypeFetching,
  editStateBusLicensePermitType,
  rowEditBusLicensePermitType,
  savingBusLicensePermitType,
} from "../atoms/atoms";
import { IBusLicensePermitType } from "../types";
import useEditType from "../hooks/useEditType";
import useAddType from "../hooks/useAddType";
import BusLicensesPermitsTypeDetails from "./BusLicensesPermitsTypeDetails";

export default function BusLicensesPermitsTypeForm(props: {
  reFetch: () => void;
}) {
  // Drilled Props
  const { reFetch } = props;
  // Atom States
  const [isAddState, setIsAddState] = useRecoilState(
    addStateBusLicensePermitType
  );
  const [actionEditState, setActionEditState] = useRecoilState(
    editStateBusLicensePermitType
  );
  const [isSaving, setIsSaving] = useRecoilState(savingBusLicensePermitType);
  const [editData, setEditData] = useRecoilState(rowEditBusLicensePermitType);
  const setIsFetching = useSetRecoilState(busLicensePermitTypeFetching);

  // Local States
  const [newData, setNewData] = useState<IBusLicensePermitType>();
  const [saveModal, setSaveModal] = useState(false);
  const [changes, setChanges] = useState(false);

  // Hook Functions
  const updateData = useEditType();
  const addData = useAddType();

  // Form Functions
  const useFormMethods = useForm({
    defaultValues: { ...editData },
  });

  const onSubmit = (data) => {
    const value = {
      ...data,
      busLicensePermitTypeName: data.busLicensePermitTypeName.trim(),
    };
    setNewData(value);
    setSaveModal(true);
    setChanges(false);
    setIsSaving(true);
  };

  const handleCancel = () => {
    useFormMethods.reset();
    useFormMethods.clearErrors();
    setEditData(undefined);
    setIsAddState(false);
    setActionEditState(false);
  };

  const handleSave = async () => {
    if (newData) {
      if (actionEditState) {
        updateData(newData);
      } else {
        addData(newData);
      }
    }

    await Timer(100);
    setIsFetching(true);
    setIsSaving(false);
    useFormMethods.reset();
    useFormMethods.clearErrors();
    setEditData(undefined);
    setIsAddState(false);
    setActionEditState(false);
    reFetch();
  };
  return (
    <>
      <div className="p-2 space-y-2 border-l-2 border-primary box-shadow">
        <FormProvider {...useFormMethods}>
          <form onSubmit={useFormMethods.handleSubmit(onSubmit)}>
            <div className="flex flex-row  justify-between items-center text-quinary font-bold font-sans text-lg pb-1">
              <div className="ml-2 font-bold text-primary text-base">
                {isAddState
                  ? "Add New Business License Permit Type"
                  : "Edit Business License Permit Type"}
              </div>
              <div className="flex justify-between gap-2 mr-2">
                <SubmitHookForm
                  type="submit"
                  disabled={!changes}
                  buttonText={isSaving ? "Saving.." : "Save"}
                  className={undefined}
                  onClick={undefined}
                />
                <CancelButton
                  onClick={(event) => {
                    event.preventDefault();
                    handleCancel();
                  }}
                />
              </div>
            </div>
            <div className="mx-2 border-b-2 border-secondary"></div>
            <div className="text-xs text-secondary italic font-normal mt-2 ml-2">
              <b> Note:</b> All fields with * are required to fill.
            </div>
          </form>
          <div>
            <BusLicensesPermitsTypeDetails
              data={editData}
              setChanges={setChanges}
            />
          </div>
        </FormProvider>
      </div>

      {saveModal && (
        <ConfirmBoxModal
          ModalTitle={
            isAddState
              ? "Add Business License Permit Type"
              : "Update Business License Permit Type"
          }
          qConfirmation={`Are you sure you want to ${
            isAddState ? "add " : "update "
          } this?`}
          isOpen={saveModal}
          onClose={() => {
            setSaveModal(false);
            setIsSaving(false);
            setChanges(true);
          }}
          onClickFunction={() => {
            setSaveModal(false);
            handleSave();
          }}
          cancelButtonRef={undefined}
        />
      )}
    </>
  );
}
